<template>
  <IonPage>
    <MapModalHeader>
      <NetworkToolbar></NetworkToolbar>
    </MapModalHeader>
    <IonContent color="white" class="bg-white">
      <IonRefresher :mode="refresherMode" slot="fixed" @ion-refresh="IonRefresh($event)">
        <IonRefresherContent :mode="refresherMode"></IonRefresherContent>
      </IonRefresher>
      <div class="px-6">
        <div
          class="text-sm font-medium text-gray-500 italic text-center m-4"
          v-if="!selectedProperty.property?.repeaters?.length"
        >
          Looks like there are <span class="text-bold text-gray-700">no repeaters installed</span> on
          {{ selectedProperty.property?.name || 'this property' }} yet. To add a repeater, tap the
          <span class="text-bold text-gray-700">"+"</span> button above.
        </div>
        <RepeaterRow v-for="r of selectedProperty.property?.repeaters" :repeater="r" :key="r.id" />
      </div>
    </IonContent>
  </IonPage>
</template>

<script setup lang="ts">
import { useSelectedProperty } from '@/stores/selected-property.store';
import { IonContent, IonHeader, IonPage, IonRefresher, IonRefresherContent } from '@ionic/vue';
import RepeaterRow from './RepeaterRow.vue';
import { useRefresherMode } from '@/composables/use-refresher-mode';
import NetworkToolbar from '../toolbars/NetworkToolbar.vue';
import MapModalHeader from '../MapModalHeader.vue';

const selectedProperty = useSelectedProperty();
const { mode: refresherMode } = useRefresherMode();

async function IonRefresh(e: CustomEvent) {
  (e.target as any)?.complete();
}
</script>

<style scoped>
/* For some reason Android needs this  */
ion-refresher {
  z-index: 10;
}
</style>
